import React, { useMemo } from 'react';
import './SegmentedProgressBar.light.scss';
import './SegmentedProgressBar.dark.scss';

interface SegmentedProgressBarProps {
  currentProgress: number;
  totalSteps: number;
}

export function SegmentedProgressBar({ currentProgress, totalSteps }: SegmentedProgressBarProps) {
  const boundedProgress = Math.max(0, Math.min(currentProgress, totalSteps));

  const completeSteps = Math.floor(boundedProgress);
  const hasPartialProgress = boundedProgress > completeSteps;
  const partialProgress = boundedProgress - completeSteps;

  const steps = useMemo(() =>
    Array.from({ length: totalSteps }, (_, i) => i + 1),
    [totalSteps]
  );

  return (
    <div className="segmented-progress-bar">
      {steps.map((step, index) => (
        <React.Fragment key={step}>
          <div
            className={`segmented-progress-bar__step ${step <= completeSteps ? 'complete' : 'incomplete'}`}
          >
            {step}
          </div>

          {index < steps.length - 1 && (
            <div className="segmented-progress-bar__connector">
              <div
                className="segmented-progress-bar__connector-background"
              />
              <div
                className="segmented-progress-bar__connector-fill"
                style={{
                  width: step < completeSteps
                    ? '100%'
                    : step === completeSteps && hasPartialProgress
                      ? `${partialProgress * 100}%`
                      : '0%'
                }}
              />
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default SegmentedProgressBar;
